import { SIGNIN_CLOSE_POPUP, SIGNIN_OPEN_NOT_FOUND , SIGNIN_OPEN_CONSENT , SIGNIN_CLOSE_CONSENT, SIGNIN_CONSENT_UPDATE  , SIGNIN_OPEN_CHANGE_DEFAULT_PASSWORD
, POPUP_OPEN_TIER_SHOW  , POPUP_CLOSE_TIER_SHOW , SIGNIN_PASSWORD_UPDATE} from "./types";

export const signinClosePopup = () => {
  return {
    type: SIGNIN_CLOSE_POPUP,
  };
};

export const signinOpenNotFound = (message) => {
  return {
    type: SIGNIN_OPEN_NOT_FOUND,
    payload: message,
  };
};


export const signinOpenConsent = (payload) => {
  return {
    type: SIGNIN_OPEN_CONSENT,
    payload: payload,
  };
};


export const signinCloseConsent = () => {
  return {
    type: SIGNIN_CLOSE_CONSENT,
  };
};


export const signOpenChangeDefaultPassword = () => {
  return {
    type: SIGNIN_OPEN_CHANGE_DEFAULT_PASSWORD,
  };
};

export const updateDefaultPassword = (payload) => {
  return {
    type: SIGNIN_PASSWORD_UPDATE,
    payload: payload,
  };
};


export const updateConcent = (payload) => {
  return {
    type: SIGNIN_CONSENT_UPDATE,
    payload: payload,
  };
};

export const popupOpenTierShow = () => {
  return {
    type: POPUP_OPEN_TIER_SHOW,
  };
};


export const popupCloseTierShow = () => {
  return {
    type: POPUP_CLOSE_TIER_SHOW,
  };
};